import * as uiTypes from '../constaints/ui';

export const showLoading = () => ({
    type: uiTypes.SHOW_LOADING,
});

export const hideLoading = () => ({
    type: uiTypes.HIDE_LOADING,
});
